export default __webpack_public_path__ + "static/media/communicate.0e3db16b.svg";